<template>
  <div class="someRunners">
    <v-card>
      <h2>Принудительный запуск</h2>
      <!-- <v-btn class="mb-2" @click="MakeBackUp">
        Создать бекап на FTP сервер
      </v-btn> -->
      <v-btn class="mb-2" @click="SendStatistic">
        Отправить статистику
      </v-btn>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "someRunners",
  components: {},
  data: () => ({}),
  methods:{
    // MakeBackUp(){
    //   this.$store.dispatch('MAKE_BACKUP_NODE_DB')
    // },
    SendStatistic(){
      this.$store.dispatch('SEND_STATISTIC')
    }
  }
};
</script>
<style lang="sass" scoped>
</style>
